/** @jsxImportSource @emotion/react */
import PageIcon from '../../../../assets/img/page-icon.svg';
import moment from 'moment';
import { FollowUpModel } from 'store/types';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
    useGetAutomatedMessagesStatusQuery,
    useToggleAutomatedMessagesMutation
} from 'store/services/messages';

interface IProps {
  followUps: FollowUpModel[]
  orderId: number
  isAutoSmsAvailable: boolean
  isFollowUpSection?: boolean
}

export const Notes = ({ followUps, orderId, isAutoSmsAvailable, isFollowUpSection = false }: IProps) => {
  const [toggleAutomatedMessages] = useToggleAutomatedMessagesMutation()
  const { data: automatedMessagesStatus, refetch: refetchAutomatedMessagesStatus } =
    useGetAutomatedMessagesStatusQuery(
      { orderId },
      {
        refetchOnFocus: false,
      },
    )
  const handleToggleAutomatedMessages = async () => {
    try {
      const currentStatus = automatedMessagesStatus?.enabled ?? true
      const newStatus = !currentStatus

      const result = await toggleAutomatedMessages({
        orderId,
        disabled: !newStatus,
      }).unwrap()

      await refetchAutomatedMessagesStatus()
      toast.success(result.message)
    } catch (error) {
      toast.error('Failed to toggle automated messages')
    }
  }

  return (
    <div
      className="p-3"
      css={{
        backgroundColor: isFollowUpSection ? '#00000005' : '#F5F5F5',
        maxHeight: 260,
        overflowY: 'auto',
      }}>
      <h4>Notes</h4>
      {followUps
        ?.filter((i) => i.comment)
        ?.map((f, index) => (
          <div
            key={`${orderId}-${index}`}
            className="p-2 mt-1"
            css={{ backgroundColor: '#C2C8CF99', borderRadius: 5 }}>
            <img src={PageIcon} className="mr-2" alt="icon" />
            <span className="mr-2" css={{ opacity: 0.5, fontWeight: '600' }}>
              {moment(f.addedAt).format('MM/DD/YYYY hh:mm a')}
            </span>
            {f.humanFollowUpRequired && (
              <span
                className="badge badge-warning mr-2"
                title={f.humanFollowUpReason || 'Human follow-up required'}>
                Human follow-up
              </span>
            )}
            Note: {f.comment}. Follow-up Date: {moment(f.date).format('MM/DD/YYYY')}
            {f.humanFollowUpRequired && f.humanFollowUpReason && (
              <div className="mt-1">
                <strong>Reason:</strong> {f.humanFollowUpReason}
              </div>
            )}
          </div>
        ))}
      {followUps?.length === 0 && (
        <div css={{ opacity: 0.7, marginBottom: 8 }}>
          There are no follow-up notes for this order
        </div>
      )}
      {isAutoSmsAvailable && (
        <div
          css={{
            display: 'flex',
            gap: '10px',
            marginTop: '10px',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}>
          <div css={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span css={{ fontSize: '14px', fontWeight: '500', color: '#666' }}>
              Automated Messages:
            </span>
            <Button
              variant={automatedMessagesStatus?.enabled ? 'success' : 'danger'}
              onClick={handleToggleAutomatedMessages}
              css={{ minWidth: '80px', fontSize: '12px' }}>
              {automatedMessagesStatus?.enabled ? 'Enabled' : 'Disabled'}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}